import React from 'react';
import cls from 'classnames';
import { Checkbox } from 'antd';
import { prefixCls } from '../type';
import './inOption.scss';
const InMultiOption = (props) => {
    const { children, iconName, disabled } = props;
    return (React.createElement("div", { className: cls(`${prefixCls}-multi`) },
        React.createElement("span", { className: `${prefixCls}-front` },
            React.createElement("span", { className: `${prefixCls}-checkbox` },
                React.createElement(Checkbox, { disabled: disabled, checked: true, className: `${prefixCls}-checked` }),
                React.createElement(Checkbox, { disabled: disabled, checked: false, className: `${prefixCls}-no-checked` })),
            React.createElement("span", { className: `${prefixCls}-main-option` },
                iconName ? React.createElement(React.Fragment, null, "icon") : null,
                React.isValidElement(children) || typeof children === 'string' ? children : props.value))));
};
export default InMultiOption;
